<template>
    <div style="background-color: white">
        <default-home-section-top />
        <default-home-section-intro />
        <section
            style="
                max-width: 70%;
                margin: 24px auto;
                padding: 16px 20px;
                border: 1px solid #f5c2c7;
                border-radius: 8px;
                background-color: #fff3cd;
                color: #664d03;
            "
        >
            <p style="margin: 0 0 8px 0; font-weight: 700">⚠️ Уважаемые пользователи!</p>
            <p style="margin: 0 0 8px 0">
                С 19:00 17 апреля по 23:00 19 апреля 2026 года планируются технические работы. В связи с этим
                сайт может быть временно недоступен.
            </p>
            <p style="margin: 0">Приносим извинения за возможные неудобства.</p>
        </section>
        <default-home-section-about />
        <default-home-section-schema />
        <default-home-section-news />
        <default-home-section-docs />
        <!-- <default-home-section-analytics /> -->
        <default-home-section-antikor />
        <default-home-section-footer />
    </div>
</template>

<script>
    export default {
        components: {
            DefaultHomeSectionTop: () => import("@/views/Home/HomeSectionTop.vue"),
            DefaultHomeSectionIntro: () => import("@/views/Home/HomeSectionIntro.vue"),
            DefaultHomeSectionSchema: () =>
                import("@/views/Home/HomeSectionSchema.vue"),
            DefaultHomeSectionAbout: () => import("@/views/Home/HomeSectionAbout.vue"),
            DefaultHomeSectionDocs: () => import("@/views/Home/HomeSectionDocs.vue"),
            DefaultHomeSectionNews: () => import("@/views/Home/HomeSectionNews.vue"),
            DefaultHomeSectionFooter: () =>
                import("@/views/Home/HomeSectionFooter.vue"),
            DefaultHomeSectionAntikor: () => import("@/views/Home/HomeAntikorSection.vue")
        },
    };
</script>
